module.exports = __webpack_public_path__ + "static/media/elevated-background.026d4e69.webp";